import { brandPrimary, brandPrimaryHover } from '../../../../web/styles/colors';
import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	container: {
		maxHeight: 'calc(100vh - 200px)',
		minHeight: 400,
		minWidth: 800,
		overflow: 'auto',
	},
	error: {
		':last-child': {
			borderBottom: '1px solid #a7abad',
		},
		borderTop: '1px solid #a7abad',
		padding: '20px 0',
	},
	errorClass: {
		color: '#858585',
		fontSize: 12,
	},
	errorContext: {
		color: brandPrimaryHover,
		fontSize: 12,
		paddingBottom: 4,
	},
	errorDate: {
		color: '#0d0F11',
		fontSize: 16,
		marginTop: 6,
	},
	errorLink: {
		':hover': {
			backgroundColor: 'rgba(0,0,0,.1)',
		},
		cursor: 'pointer',
	},
	errorMessage: {
		color: brandPrimary,
		fontSize: 16,
	},
	errorsNone: {
		color: '#858585',
		fontSize: 14,
		marginTop: 30,
		textAlign: 'center',
		textTransform: 'uppercase',
	},
	errorSubtitle: {
		color: '#858585',
		fontSize: 16,
		letterSpacing: 1,
		marginBottom: 20,
		paddingTop: 20,
		textTransform: 'uppercase',
	},
	title: {
		color: brandPrimary,
		fontSize: 22,
		fontWeight: 600,
		maxWidth: '80%',
		position: 'absolute',
		top: -20,
	},
});
